import {Module} from 'vuex';
import {IRootStore} from './root-store.type';

const namespaced = false;

export enum RootStoreGetters {
  version = 'version',
  problemSessionId = 'problemSessionId',
}
export enum RootStoreActions {
  updateVersion = 'updateVersion',
  updateSessionId = 'updateSessionId',
}
export enum RootStoreMutations {
  updateVersion = 'updateVersion',
  saveSessionId = 'saveSessionId',
}

export const rootStoreModule: Module<IRootStore, {}> = {
  namespaced,
  state: {
    version: '',
    problemSessionId: '',
  },
  getters: {
    [RootStoreGetters.version]: (state: IRootStore) => state.version,
    [RootStoreGetters.problemSessionId]: (state: IRootStore) => state.problemSessionId,
  },
  actions: {
    [RootStoreActions.updateVersion]: ({commit}, version: string) => {
      return commit(RootStoreMutations.updateVersion, version);
    },
    [RootStoreActions.updateSessionId]: ({commit}, sessionId: string) => {
      return commit(RootStoreMutations.saveSessionId, sessionId);
    },
    [RootStoreActions.updateVersion]: ({commit}, version: string) => {
      return commit(RootStoreMutations.updateVersion, version);
    },
  },
  mutations: {
    [RootStoreMutations.updateVersion]: (state: IRootStore, version: string) => {
      state.version = version;
    },
    [RootStoreMutations.saveSessionId]: (state: IRootStore, value: string) => {
      state.problemSessionId = value;
    },
    reset: () => {},
  },
};
